<template>
  <el-dialog class="setting" title="设置" :visible.sync="visible" width="480px" :before-close="onClose">
    <el-tabs v-model="activeTab" type="border-card">
      <!-- 个人资料标签页 -->
      <el-tab-pane label="个人资料" name="profile">
        <el-form :model="userInfo" label-width="80px" :rules="rules" ref="settingForm" size="small">
          <el-form-item label="头像" style="margin-bottom: 0 !important;">
            <file-upload class="avatar-uploader" :action="imageAction" :showLoading="true" :maxSize="maxSize"
              @success="onUploadSuccess" :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
              <img v-if="userInfo.headImage" :src="userInfo.headImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </file-upload>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input disabled v-model="userInfo.userName" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="nickName" label="昵称">
            <el-input v-model="userInfo.nickName" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="userInfo.sex">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="个性签名">
            <el-input type="textarea" v-model="userInfo.signature" :rows="3"></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 修改密码标签页 -->
      <el-tab-pane label="修改密码" name="password">
        <el-form :model="passwordForm" label-width="100px" :rules="passwordRules" ref="passwordForm" size="small">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input
              v-model="passwordForm.oldPassword"
              type="password"
              autocomplete="off"
              size="small"
              show-password
              placeholder="请输入当前密码">
            </el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="passwordForm.newPassword"
              type="password"
              autocomplete="off"
              size="small"
              show-password
              placeholder="请输入新密码">
            </el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPassword">
            <el-input
              v-model="passwordForm.confirmPassword"
              type="password"
              autocomplete="off"
              size="small"
              show-password
              placeholder="请再次输入新密码">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-alert
              title="密码要求：长度至少6位"
              type="info"
              :closable="false"
              show-icon>
            </el-alert>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose()">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" v-if="activeTab === 'profile'">保存资料</el-button>
      <el-button type="primary" @click="onChangePassword()" v-if="activeTab === 'password'">修改密码</el-button>
    </span>
  </el-dialog>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";

export default {
  name: "setting",
  components: {
    FileUpload
  },
  data() {
    // 自定义验证器：确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    return {
      activeTab: 'profile', // 当前激活的标签页
      userInfo: {},
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      maxSize: 5 * 1024 * 1024,
      action: "/image/upload",
      rules: {
        nickName: [{
          required: true,
          message: '请输入昵称',
          trigger: 'blur'
        }]
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {

    onClose() {
      // 重置表单
      this.resetPasswordForm();
      this.$emit("close");
    },

    onSubmit() {
      this.$refs['settingForm'].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$http({
          url: "/user/update",
          method: "put",
          data: this.userInfo
        }).then(() => {
          this.$store.commit("setUserInfo", this.userInfo);
          this.$emit("close");
          this.$message.success("修改成功");
        })
      });
    },

    // 修改密码
    onChangePassword() {
      this.$refs['passwordForm'].validate((valid) => {
        if (!valid) {
          return false;
        }

        // 显示确认对话框
        this.$confirm('确定要修改密码吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 调用修改密码接口
          this.$http({
            url: "/user/password",
            method: "put",
            data: {
              oldPassword: this.passwordForm.oldPassword,
              newPassword: this.passwordForm.newPassword
            }
          }).then(() => {
            this.$message.success("密码修改成功，请重新登录");
            // 重置密码表单
            this.resetPasswordForm();
            // 关闭对话框
            this.$emit("close");
            // 退出登录
            setTimeout(() => {
              this.$store.commit("reset");
              this.$router.push("/login");
            }, 1500);
          }).catch((error) => {
            // 处理错误
            if (error.response && error.response.data && error.response.data.message) {
              this.$message.error(error.response.data.message);
            } else {
              this.$message.error("密码修改失败");
            }
          });
        }).catch(() => {
          // 取消修改
        });
      });
    },

    // 重置密码表单
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      if (this.$refs['passwordForm']) {
        this.$refs['passwordForm'].resetFields();
      }
    },

    onUploadSuccess(data, file) {
      this.userInfo.headImage = data.originUrl;
      this.userInfo.headImageThumb = data.thumbUrl;
    }
  },
  props: {
    visible: {
      type: Boolean
    }
  },
  computed: {
    imageAction() {
      return `/image/upload`;
    }
  },
  watch: {
    visible: function (newData, oldData) {
      if (newData) {
        // 深拷贝
        let mine = this.$store.state.userStore.userInfo;
        this.userInfo = JSON.parse(JSON.stringify(mine));
        // 重置密码表单
        this.resetPasswordForm();
        // 默认显示个人资料标签页
        this.activeTab = 'profile';
      }
    }
  }
}
</script>

<style lang="scss">
.setting {
  .el-tabs--border-card {
    border: none;
    box-shadow: none;

    .el-tabs__header {
      background-color: #f5f7fa;
      border-bottom: 1px solid #e4e7ed;
    }

    .el-tabs__content {
      padding: 20px 10px;
      min-height: 300px;
    }
  }

  .el-form {
    padding: 10px 0 0 10px;
  }

  .avatar-uploader {
    --width: 112px;

    .el-upload {
      border: 1px dashed #d9d9d9 !important;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .el-upload:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 24px;
      color: #8c939d;
      width: var(--width);
      height: var(--width);
      line-height: var(--width);
      text-align: center;
    }

    .avatar {
      width: var(--width);
      height: var(--width);
      display: block;
    }
  }

  // 密码标签页样式
  .el-tab-pane[name="password"] {
    .el-form {
      max-width: 400px;
      margin: 0 auto;
    }

    .el-alert {
      margin-top: 10px;
    }
  }
}
</style>
